module.exports = __webpack_public_path__ + "img/icon_arrow-left.e4e84b90.svg";